import {take, fork, call, cancel} from 'redux-saga/effects';

export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export function * takeFirst (action, callback) {
    while (true) {
        const a = yield take(action);
        yield callback(a);
        yield call(delay, 500);
    }
}




// WEBPACK FOOTER //
// ./src/sagas/helperSaga.js